'use client'

import { Modal, Skeleton } from '@mantine/core'
import { useTranslations } from 'next-intl'
import styles from './PersonaSelectModal.module.css'
import { usePersonaAddPopup } from './usePersonaAddPopup'

export const productMap: Record<
  string,
  { color: string; label: string; url: string }
> = {
  CO_OWNER: {
    color: '#3F7EF5',
    label: 'Co-ownership',
    url: '/dashboard',
  },
  LANDLORD: {
    color: '#D97C35',
    label: 'Landlord',
    url: '/stays/landlord',
  },
  RENTER_CUSTOMER: { color: '#AD68A4', label: 'Stays', url: '/stays' },
  INDIVIDUAL_SELLER: { color: '', label: 'Seller', url: '' },
  PROPERTY_DEVELOPER: { color: '', label: 'Developer', url: '' },
  BROKER: { color: '', label: 'Broker', url: '' },
}

interface PersonaSelectModalProps {
  opened: boolean
  onClose: () => void
}

export const PersonaSelectModal = ({
  opened,
  onClose,
}: PersonaSelectModalProps) => {
  const t = useTranslations('Ui.persona-modal')
  const { accountRoles, isLoading } = usePersonaAddPopup(opened)
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      lockScroll={false}
      size={600}
      radius='md'
      overlayProps={{ backgroundOpacity: 0.5, blur: 3 }}
      styles={{
        content: { padding: '28px 24px', borderRadius: '12px' },
      }}
      title={
        <div>
          <h2 className={styles.modalTitle}>{t('title')}</h2>
          <p className={styles.modalSubtitle}>{t('subtitle')}</p>
        </div>
      }
    >
      <div className={styles.productContainer}>
        {isLoading
          ? Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} radius={10} h={200} flex={1} />
            ))
          : accountRoles
              ?.filter(
                (el) => el.persona === 'OWNER' || el.persona === 'RENTER',
              )
              .map((p) => (
                <a
                  key={p.account_role_id}
                  className={styles.productCard}
                  href={productMap[p?.display_name]?.url}
                >
                  <div
                    className={styles.iconCircle}
                    style={{
                      backgroundColor:
                        productMap[p?.display_name]?.color || '#000',
                    }}
                  >
                    {productMap[p?.display_name]?.label[0]}
                  </div>
                  <h3 className={styles.productLabel}>
                    {productMap[p?.display_name]?.label}
                  </h3>
                  <p className={styles.productDescription}>{p.description}</p>
                </a>
              ))}
      </div>
    </Modal>
  )
}
